import { Paper, styled } from '@mui/material';

export const ElectedDetailsSectionStyled = styled('div')({
  borderTop: '1px solid #E6E6E6',
});

export const LogoPaperStyled = styled(Paper)({
  border: '1px solid var(--neutral-grey-200, #E6E6E6)',
  boxShadow: 'none',
  borderRadius: '4px',
  width: '28%',
  '@media screen and (max-width: 576px)': {
    width: '100%',
  },
});

export const FamilyCoveredStyled = styled('div')({
  gap: '20px',
});

export const BkgImageStyled = styled('div')({
  top: '0',
});

export const BkgpathStyled = styled('path')<{ colorNum: string }>(
  ({ colorNum }) => ({
    fill: `var(--annotation-${colorNum})`,
  })
);

export const BenefitNameStyled = styled('h3')({
  '@media screen and (max-width: 576px)': {
    fontSize: '14px',
  },
});

export const LastYearBenefitCardContentStyled = styled('div')({
  '@media screen and (max-width: 576px)': {
    borderBottom: '1px solid var(--neutral-grey-200, #E6E6E6)',
  },
});

export const CarrierImageStyled = styled('img')({
  maxWidth: '100%',
  maxHeight: '100%',
  width: '80%',
});

// create a dynamically colored div. The "swoosh" will be provided with an image mask, similarly to how we did the hero image
export const ColorSplashStyled = styled('div')<{ colorNum: string }>(
  ({ colorNum }) => ({
    backgroundColor: `var(--annotation-${colorNum})`,
  })
);
